import { parseTime } from '@/utils/util'

export const searchForm = {
  type_id: undefined
}

export const rules = {
  name: [ { required: true, message: '请首输入名称', trigger: 'change' } ],
  modules: [ { required: true, trigger: 'change', message: '请选择归属模块' } ]
}

export const columns = [
  {
    title: '序号',
    align: 'center',
    width: 120,
    dataIndex: 'id'
  },
  {
    title: '名称',
    align: 'left',
    width: 320,
    dataIndex: 'name'
  },
  {
    title: '归属模块',
    align: 'left',
    dataIndex: 'module_select',
    width: 360,
    scopedSlots: { customRender: 'module_select' }
  },
  {
    title: '创建人工号',
    align: 'left',
    dataIndex: 'create_uid'
  },
  {
    title: '创建时间',
    align: 'left',
    dataIndex: 'created_at',
    customRender(text) {
      return parseTime(text)
    }
  },
  {
    title: '更新时间',
    align: 'left',
    dataIndex: 'updated_at',
    customRender(text) {
      return parseTime(text)
    }
  },
  {
    title: '操作',
    align: 'center',
    width: 200,
    dataIndex: 'operator',
    scopedSlots: { customRender: 'operator' }
  }
]
